<template>
    <v-dialog max-width="500px" v-model="inDialog" @click:outside="onClickOutside" persistent>
        <v-card>
            <v-form ref="viewPresentForm">
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px">{{
                            $t(formCreateName)
                        }}</v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="position: absolute; right: 10px; top: 10px; color: #fff"
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>

                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Mã khu')"
                                v-model.trim="item.categoryCode"
                                name="categoryCode"
                                v-validate="'required'"
                                maxLength="250"
                                :error-messages="errors.first('categoryCode')"
                                :data-vv-as="$t('Mã khu')"
                                disabled
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Tên khu')"
                                v-model.trim="item.categoryName"
                                name="categoryName"
                                v-validate="'required'"
                                maxLength="250"
                                :error-messages="errors.first('categoryName')"
                                :data-vv-as="$t('Tên khu')"
                            ></v-text-field>
                        </v-flex>
                        <!--v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Ký hiệu')"
                                v-model.trim="item.parentName"
                                name="parentName"
                                v-validate="'required'"
                                maxLength="250"
                                :error-messages="errors.first('parentName')"
                                :data-vv-as="$t('Ký hiệu')"
                                @keyup="uppercase"
                            ></v-text-field>
                        </v-flex-->
                        <v-flex xs12>
                            <v-select
                                :items="areaStatus"
                                :label="$t('Trạng thái')"
                                v-model="item.status"
                                name="status"
                                item-value="value"
                                item-text="text"
                                :data-vv-as="$t('Trạng thái')"
                                :error-messages="errors.first('status')"
                            />
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <!-- </v-container> -->
            </v-form>
            <div style="text-align: right">
                <v-btn color="primary" @click="onSave">
                    <v-icon dark left>save</v-icon>
                    {{ $t("lang.common.save") }}
                </v-btn>
                <v-btn color="error" @click="onCancel">
                    <v-icon dark left>cancel</v-icon>
                    {{ $t("lang.common.cancel") }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { message } from "../../../services";
import axios from "axios";
import { areaContants } from "@/constants";

export default {
    name: "pond-area-create",
    components: { message, axios },
    props: {
        propsItem: {
            type: Object,
            default: () => {
                    return {}
                }
        },
        cDialog: {
            type: Boolean,
            default: false,
        },
        formCreateName: {
            type: String,
            default: '',
        },
    },
    data: () => {
        return {
            areaStatus: areaContants.areaStatus,
            item: {
                categoryCode: "",
                categoryName: "",
                parentName: "",
                categoryTypeCode: "PONDAREA",
                status: 1,
            },
            inDialog: false,
        };
    },
    watch: {
        propsItem: {
            handler(value) {
                //console.log(value);
                if (value !== null) {
                    this.item = {
                        categoryId: value.categoryId,
                        categoryCode: value.categoryCode
                            ? value.categoryCode
                            : "",
                        categoryName: value.categoryName
                            ? value.categoryName
                            : "",
                        parentName: value.parentName
                            ? value.parentName
                            : "",
                        status: value.status ? value.status : 0,
                    };
                } else {
                    this.resetFrom();
                }
            },
            deep: true,
        },
        cDialog(value) {
            this.inDialog = value;
        },
        inDialog (value) {
            if(!value){
                this.$emit("closeCreateDialog", "");
            }
        },
    },
    methods: {
        resetFrom: function () {
            this.item = {
                categoryCode: "",
                categoryName: "",
                parentName: "",
                categoryTypeCode: "PONDAREA",
                status: 1,
            };
        },
        onCancel: function () {
            this.$emit("closeCreateDialog", "");
        },
        onSave: function () {
            // console.log(this.item);
            this.$validator.validate().then((valid) => {
                if (!valid) {
                    message.error(this.$t("lang.common.validate_fail"));
                    return;
                }
                axios
                    .post(
                        process.env.VUE_APP_API_URL +
                            "/category/save?categoryTypeCode=PONDAREA",
                        this.item
                    )
                    .then(
                        (data) => {
                            if (data.success) {
                                message.success(
                                    this.$t("lang.common.save_success")
                                );
                                this.resetFrom();
                                this.onCancel();
                            } else {
                                let msg = data.description;
                                if (data.description === 'lang.category.duplicateCode') {
                                    msg = 'lang.pondArea.duplicateCode';
                                } else if (data.description === 'lang.category.duplicateName') {
                                    msg = 'lang.pondArea.duplicateCode';
                                } else if (data.description === 'lang.category.duplicateParentName') {
                                    msg = 'lang.pondArea.duplicateSymbol';
                                }
                                message.error(this.$t(msg));
                            }
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
            });
        },
        // onClickOutside : function () {
        //     alert(1);
        // },
        uppercase() {
            this.item.parentName = this.item.parentName.toUpperCase();
        },
    },
    created() {},
};
</script>
